import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const AuthField = ({ label, icon: Icon, type = "text", right, testId, ...props }) => {
  const [show, setShow] = useState(false);
  const isPw = type === "password";
  return (
    <div>
      <div className="mb-1.5 flex items-center justify-between">
        <label className="text-sm font-medium text-slate-800">{label}</label>
        {right}
      </div>
      <div className="relative">
        {Icon && <Icon size={16} className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />}
        <input
          type={isPw && show ? "text" : type}
          className={`h-12 w-full rounded-lg border border-slate-200 bg-slate-50 text-sm text-slate-900 placeholder:text-slate-400 transition-[border-color,box-shadow,background-color] focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-4 focus:ring-blue-500/15 ${Icon ? "pl-10" : "pl-3.5"} ${isPw ? "pr-11" : "pr-3.5"}`}
          data-testid={testId}
          {...props}
        />
        {isPw && (
          <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700" data-testid={`${testId}-toggle`} aria-label={show ? "Hide password" : "Show password"}>
            {show ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        )}
      </div>
    </div>
  );
};

export const AuthSubmit = ({ children, loading, testId, ...props }) => (
  <button type="submit" disabled={loading || props.disabled} data-testid={testId} {...props}
    className="group flex h-12 w-full items-center justify-center gap-2 rounded-lg bg-gradient-to-r from-blue-700 to-blue-500 text-sm font-semibold text-white shadow-lg shadow-blue-600/25 transition-[transform,box-shadow,opacity] hover:-translate-y-0.5 hover:shadow-blue-600/40 disabled:opacity-60 disabled:hover:translate-y-0">
    {children}
  </button>
);
